module.exports = __webpack_public_path__ + "media/fonts/Gotham Bold-19cbd08d9da163ba87d64997ae97988e.otf";